import { Modal, Button } from 'antd';
import React, { useRef, useState } from 'react';

const TermsOfUseModal = ({ visible, onCancel, handleAcceptTerms }) => {
   const contentRef = useRef(null);
   const [isEndScroll, setIsEndScroll] = useState(false);

   const handleCloseModal = () => {
      onCancel();
      contentRef.current.scrollTo({ top: 0 });
      setIsEndScroll(false);
   };

   const handleEndScroll = (e) => {
      const element = e.target;
      const scrollTop = element.scrollTop;
      const scrollHeight = element.scrollHeight;
      const clientHeight = element.clientHeight;

      if (scrollTop + clientHeight >= scrollHeight - 10) {
         setIsEndScroll(true);
      } else {
         setIsEndScroll(false);
      }
   };

   const footer = (
      <div>
         <Button
            shape='round'
            disabled={!isEndScroll}
            onClick={() => {
               handleAcceptTerms();
               handleCloseModal();
            }}
         >
            ยอมรับ
         </Button>
      </div>
   );

   const modalConfig = {
      visible: visible,
      width: 900,
      footer: footer,
      onCancel: handleCloseModal,
      className: 'terms-of-use-modal',
      style: { top: 16 }
   };

   return (
      <Modal {...modalConfig}>
         <div className='title-container'>
            <h1>เงื่อนไขการใช้บริการ</h1>
            <p>กรุณาเลื่อนลงเพื่ออ่านข้อมูลทั้งหมด ก่อนกดยอมรับ</p>
         </div>
         <div ref={contentRef} className='terms-of-use-content' onScroll={handleEndScroll}>
            <div>
               <h2>เงื่อนไขการใช้บริการ</h2>
               <p style={{ marginBottom: '1rem' }}>
                  โปรดอ่านทำความเข้าใจตามเงื่อนไขและข้อตกลงก่อนทำการลงทะเบียน หลังจากลงทะเบียนเสร็จ สมบูรณ์แล้ว
                  ถือว่าท่านยอมรับเงื่อนไขและข้อตกลง ระหว่างนักเขียน กับ บริษัท ไฮเท็คซ์ อินเตอร์แอคทีฟ จำกัด หรือ
                  www.hytexts.com
               </p>
               <p>โดยทั้งสองฝ่ายตกลงทำข้อตกลงกัน ซึ่งมีข้อความดังต่อไปนี้</p>
            </div>

            <div>
               <h2>หนังสืออิเล็กทรอนิกส์ (E-BOOK)</h2>
               <ol>
                  <li>
                     หนังสืออิเล็กทรอนิกส์ที่ถูกตั้งราคาขายใน www.hytexts.com จะถูกเข้ารหัสเพื่อจัดการลิขสิทธ์ (Digital
                     Right Management) ยกเว้นหนังสือ อิเล็กทรอนิกส์ที่จัดจำหน่ายแบบ DRM-Free
                  </li>

                  <li>
                     สมาชิกจะต้องสมัคร Adobe ID ก่อนที่จะดาวน์โหลดหนังสืออิเล็กทรอนิกส์
                     เพื่อที่จะสามารถนำไปอ่านบนอุปกรณ์ในระบบต่าง ๆ เช่น iOS, Android, Window, Mac OS และเครื่อง E-Reader
                  </li>

                  <li>สมาชิกสามารถ Authorize อุปกรณ์พกพาได้ สูงสุด 5 อุปกรณ์ ต่อ 1 Adobe ID</li>

                  <li>
                     หนังสืออิเล็กทรอนิกส์ และตัวอย่างหนังสือ อิเล็กทรอนิกส์ ที่ถูกจัดจำหน่ายโดย www.hytexts.com
                     ห้ามทำซ้ำ ดัดแปลง แก้ไข เผยแพร่ จัดจำหน่าย โดยไม่ได้รับอนุญาตจาก www.hytexts.com
                  </li>
               </ol>
            </div>

            <div>
               <h2>นักเขียน</h2>
               <p>นักเขียนจะต้องมีอายุมากกว่า 18 ปีบริบูรณ์ จึงจะ สามารถวางขาย E-Book กับ www.hytexts.com</p>
            </div>
            <div>
               <h2>1. ผลงานลิขสิทธิ์</h2>
               <p>
                  นักเขียนตกลงว่าข้อมูลอิเล็กทรอนิกส์ หรืองาน วรรณกรรมในรูปแบบหนังสืออิเล็กทรอนิกส์ (E-Book)
                  ของนักเขียนที่ส่งให้ www.hytexts.com จำหน่ายให้แก่ลูกค้านั้น เป็นข้อมูลที่สามารถเข้าถึง
                  และนำกลับมาใช้ใหม่ได้ โดยความหมาย ไม่เปลี่ยนแปลงและในกรณีที่ต้องมีบุคคลลงชื่อ ในหนังสือ
                  ให้ถือว่าข้อมูลทางอิเล็กทรอนิกส์นั้น ได้มีการลงลายมือชื่อแล้ว และนักเขียนได้รับอนุญาต ให้จัดทำ จำหน่าย
                  โฆษณา เผยแพร่ จากเจ้าของ ลิขสิทธิ์ที่แท้จริงถูกต้องตามกฎหมายแล้วและ เผยแพร่งานวรรณกรรมในรูปแบบหนังสือ
                  อิเล็กทรอนิกส์ของนักเขียนบน www.hytexts.com ได้ โดยไม่ขัดต่อข้อตกลงกับบุคคลอื่น
               </p>
            </div>

            <div>
               <h2>2. เงื่อนไขการอนุญาต</h2>
               <p>
                  นักเขียนตกลงให้ www.hytexts.com มีอำนาจกระทำการแทนดังต่อไปนี้ <br />
                  Hytexts.com มีอำนาจจัดทำ จำหน่าย โฆษณา งานวรรณกรรมในรูปแบบหนังสืออิเล็กทรอนิกส์
                  และการทำธุรกรรมทางพาณิชย์อิเล็กทรอนิกส์ผ่าน ระบบเครือข่ายอินเตอร์เน็ตที่เกี่ยวกับกิจการใน เชิงพาณิชย์
                  ด้วยการทำซ้ำงานวรรณกรรมในรูปแบบ
                  หนังสืออิเล็กทรอนิกส์และนำส่งข้อมูลงานวรรณกรรมในรูปแบบหนังสืออิเล็กทรอนิกส์ให้แก่ลูกค้าบน
                  www.hytexts.com เพื่อวัตถุประสงค์ในการจัด จำหน่ายในรูปแบบหนังสืออิเล็กทรอนิกส์ใน
                  ประเทศไทยและในต่างประเทศ โดยผ่านทาง www.hytexts.com หรือ ผ่านทางแอปพลิชั่น ในแพลตฟอร์มอื่นๆ ของทาง
                  www.hytexts.com
               </p>
            </div>

            <div>
               <h2>3. การจัดทำหนังสืออิเล็กทรอนิกส์</h2>
               <ol>
                  <li>
                     นักเขียนตกลงนำส่งข้อมูลงานวรรณกรรมในรูปแบบหนังสืออิเล็กทรอนิกส์ที่ชอบด้วยกฎหมาย เข้าสู่ระบบ
                     (Upload) ผ่านทางบัญชีผู้ใช้งานบน www.hytexts.com
                     โดยผู้ส่งจะต้องลงลายมือชื่อหรือยอมรับเงื่อนไขของทาง www.hytexts.com เพื่อให้เราจัดจำหน่าย โฆษณา
                     เผยแพร่ งานวรรณกรรมในรูปแบบหนังสืออิเล็กทรอนิกส์ได้
                  </li>

                  <li>
                     ตกลงว่าจะจัดจำหน่ายโดยวิธีโฆษณาและเผยแพร่งานวรรณกรรมในรูปแบบหนังสืออิเล็กทรอนิกส์ ภายใน เวลา 5 วัน
                     นับตั้งแต่วันที่ได้รับข้อมูลหนังสือ อิเล็กทรอนิกส์ และจะไม่แก้ไขเปลี่ยนแปลงหรือ
                     ละเมิดลิขสิทธิ์ของเจ้าของเดิม ยกเว้นการแก้ไข ในรูปแบบการจัดวางตัวหนังสือ เพื่อความเหมาะสม
                     ในการจัดจำหน่ายในรูปแบบหนังสืออิเล็กทรอนิกส์
                  </li>

                  <li>
                     ในกรณีที่นักเขียนส่งต้นฉบับงานวรรณกรรมให้ที่เป็น ไฟล์ Microsoft Words หรือ ไฟล์อื่นๆ ให้
                     www.hytexts.com จัดทำหนังสืออิเล็กทรอนิกส์ ์เป็นไฟล์ ePub เพื่อ จัดจำหน่ายใน www.hytexts.com
                     ให้ถือว่าข้อมูล หนังสืออิเล็กทรอนิกส์นั้น เป็นงานของ www.hytexts.com ห้ามไม่ผู้ใดจัดจำหน่าย
                     เว้นแต่จะได้รับอนุญาตจาก www.hytexts.com
                  </li>

                  <li>
                     www.hytexts.com ตกลงว่าจะทำการเข้ารหัสหนังสืออิเล็กทรอนิกส์
                     เพื่อป้องกันการละเมิดลิขสิทธิ์ด้วยระบบของ Adobe Content Server 4 หรือเทียบเท่า เฉพาะหนังสือ
                     อิเล็กทรอนิกส์ที่ถูกตั้งราคาขาย แต่ยกเว้นหนังสือ อิเล็กทรอนิกส์ที่จัดจำหน่ายสำหรับอุปกรณ์ Kindle
                  </li>

                  <li>
                     นักเขียนตกลงว่าจะส่งตัวอย่างงานวรรณกรรม ในรูปแบบหนังสืออิเล็กทรอนิกส์โดยจะต้องมีเนื้อหา ไม่น้อยกว่า
                     3 บท หรือ 10% ของจำนวนหน้าทั้งหมด ของงานวรรณกรรม ซึ่งตัวอย่างงานวรรณกรรมนี้
                     จะไม่ถูกเข้ารหัสหนังสืออิเล็กทรอนิกส์เพื่อจัดการ ลิขสิทธิ์ และจะถูกใช้เพื่อประชาสัมพันธ์ หรือ
                     โฆษณางานวรรณกรรมเท่านั้น
                  </li>

                  <li>การจัดหน้า พิสูจน์อักษร ออกแบบปก และภาพประกอบ นักเขียนต้องเป็นผู้จัดทำด้วยตนเอง</li>
               </ol>
            </div>

            <div>
               <h2>4. ข้อกำหนดเนื้อหาของงานวรรณกรรม</h2>
               <p>
                  www.hytexts.com มีหน้าที่ตรวจรูปแบบ การจัดวางปก และข้อมูลหนังสืออิเล็กทรอนิกส์ให้
                  เหมาะสมกับการจัดจำหน่ายเท่านั้น โดยไม่มีหน้าที่ ตรวจสอบ เนื้อหา เนื้อเรื่อง ภาพประกอบ ลิขสิทธิ์
                  หรือส่วนหนึ่งส่วนใด ของหนังสืออิเล็กทรอนิกส์ ที่นักเขียนนำส่งข้อมูล ดังนั้นนักเขียนตกลงว่า
                  จะไม่นำงานวรรณกรรมที่มีเนื้อหา เนื้อเรื่อง ภาพประกอบหรือส่วนหนึ่งส่วนใดดังต่อไปนี้ให้ www.hytexts.com
                  จัดจำหน่าย โฆษณาและ เผยแพร่ ใน www.hytexts.com
               </p>
               <ol>
                  <li>
                     งานวรรณกรรมที่มีเนื้อหาหมิ่นประมาท หรือแสดงความอาฆาตมาดร้าย พาดพิงสถาบัน พระมหากษัตริย์
                     รัชทายาทราชวงศ์ หรือผู้สำเร็จ ราชการแทนพระองค์ เป็นอันขาด
                  </li>
                  <li>งานวรรณกรรมที่กล่าวโจมตี หรือวิพากษ์วิจารณ์ในทางเสียหายต่อศาสนา หรือคำสอนของศาสนาใดๆ ทุกศาสนา</li>
                  <li>งานวรรณกรรมที่มีเนื้อหาหมิ่นประมาท หรือละเมิดสิทธิ์ส่วนบุคคลที่มีต่อบุคคลอื่นหรือหน่วยงานใด</li>
                  <li>งานวรรณกรรมที่คัดลอกผลงาน หรือบทความ บนเว็บไซต์ของบุคคลอื่น</li>
                  <li>งานวรรณกรรมที่มีเนื้อหาละเมิดกฎหมาย หรือสนับสนุนกิจกรรมที่ผิดกฎหมาย</li>
                  <li>
                     งานวรรณกรรมที่มีเนื้อหามีภาพประกอบหรือ ภาพบุคคลอื่นที่มีลักษณะหมิ่นประมาทหรือละเมิดสิทธิ์ส่วนบุคคล
                  </li>
                  <li>
                     งานวรรณกรรมที่มีเนื้อหามีการโฆษณาใน วัตถุประสงค์ เพื่อใช้ในการโฆษณางานวรรณกรรม
                     เดียวกันที่จัดจำหน่ายในที่อื่นนอกเหนือจาก www.hytexts.com
                  </li>
                  <li>งานวรรณกรรมที่มี ตัวอักษร หน้าปก หรือ ภาพประกอบที่ละเมิดลิขสิทธิ์ของบุคคลอื่น</li>
               </ol>
            </div>

            <div>
               <h2>5. ค่าตอบแทน</h2>
               <p>
                  5.1 ค่าตอบแทนการขายผ่าน www.hytexts.com www.hytexts.com ตกลงจัดส่งค่าตอบแทนการ
                  ขายหนังสืออิเล็กทรอนิกส์ให้แก่นักเขียน ในอัตรา ร้อยละ 65 ของราคาขายหนังสืออิเล็กทรอนิกส์
                  คูณจำนวนหนังสืออิเล็กทรอนิกส์ที่ลูกค้าชำระเงิน เสร็จสมบูรณ์บน www.hytexts.com ทั้งหมด
               </p>
               <p>5.2 ค่าตอบแทนการขายผ่าน Apple In-app Purchased</p>
               <ol>
                  <li>นักเขียนเป็นผู้กำหนดราคาขายหนังสือ อิเล็กทรอนิกส์เป็นสกุลเงิน US Dollar</li>
                  <li>
                     www.hytexts.com ตกลงจัดส่งค่าตอบแทน การขายหนังสืออิเล็กทรอนิกส์ให้แก่นักเขียน ในอัตรา ร้อยละ 49
                     ของราคาขายหนังสืออิเล็กทรอนิกส์ คูณ จำนวนหนังสืออิเล็กทรอนิกส์ที่ลูกค้าชำระเงินเสร็จ
                     สมบูรณ์ผ่านทางระบบ In-app Purchased ของ บริษัท Apple Inc โดยอ้างอิงจากอัตราแลกเปลี่ยน
                     สกุลเงินจากทางบริษัท Apple Inc (บริษัท Apple Inc คิดค่าธรรมเนียมระบบ In-app Purchased 30%
                     ของราคาขายหนังสืออิเล็กทรอนิกส์)
                  </li>
               </ol>

               <p>5.3 การจ่ายค่าตอบแทน</p>
               <ol>
                  <li>
                     www.hytexts.com ตกลงจะแจ้งให้นักเขียนทราบ
                     ผลการจำหน่ายหนังสืออิเล็กทรอนิกส์ทุกครั้งเมื่อมีการซื้อขายกับบุคคลภายนอกสำเร็จ โดยแจ้งผ่านทางชื่อ
                     บัญชีผู้ใช้งานของนักเขียนที่ลงทะเบียนไว้ที่ www.hytexts.com
                  </li>
                  <li>
                     นักเขียนสามารถตรวจสอบรายละเอียดและยอด ขายงานวรรณกรรมในรูปแบบหนังสืออิเล็กทรอนิกส์
                     ผ่านชื่อบัญชีผู้ใช้งานของนักเขียนที่ลงทะเบียน ไว้ในระบบ
                  </li>
                  <li>
                     สำหรับการขายผ่าน Apple In-app Purchased จะมีการนำส่งเงินค่าตอบแทนภายใน ระยะเวลา 60
                     วันหลังจากได้ทำการส่งรายงานยอดขายที่เกิดขึ้นให้ กับนักเขียน
                  </li>
                  <li>
                     www.hytexts.com จะนำส่งเงินค่าตอบแทน ทุกวันที่ 20 ของแต่ละเดือน หรือวันทำการถัดไป หากติดวันหยุด
                     โดยเข้าบัญชีข้อมูลธนาคารที่ ลงทะเบียนไว้ในระบบ
                  </li>
                  <li>
                     นักเขียนยินยอมให้หักภาษี ณ ที่จ่าย ตามอัตรา ที่ระบุในประมวลรัษฎากรจากค่าตอบแทนที่จ่ายทุกครั้ง โดย
                     www.hytexts.com จะออกหนังสือรับรองการ หักภาษี ณ ที่จ่าย และรวบรวมส่งมอบให้แก่นักเขียน
                     ในเดือนกรกฎาคม และมกราคมของทุกปี
                  </li>

                  <li>
                     ในการชำระค่าตอบแทน นักเขียนจะรับผิดชอบ ค่าธรรมเนียมในการโอนเงินผ่านธนาคาร โดย www.hytexts.com
                     จะหักค่าธรรมเนียมใน การโอนเงินผ่านธนาคาร ที่จ่ายตามอัตราที่ธนาคาร
                     ระบุไว้จากค่าตอบแทนที่จ่ายทุกครั้ง
                  </li>
               </ol>
            </div>

            <div>
               <h2>6. สิทธิ์เจ้าของลิขสิทธิ์</h2>
               <p>
                  ภายใต้ข้อบังคับแห่งข้อตกลงฉบับนี้ นักเขียนยังคง
                  เป็นเจ้าของลิขสิทธิ์ในงานวรรณกรรมตามข้อตกลงนี้ทุกประการ
               </p>
            </div>

            <div>
               <h2>7. การระบุชื่อผู้สร้างสรรค์ เจ้าของลิขสิทธิ์ และข้อมูลอื่นๆ</h2>
               <p>
                  ในการจัดทำงานวรรณกรรมในรูปแบบหนังสืออิเล็กทรอนิกส์ทุกครั้ง นักเขียนจะต้องระบุชื่อผู้สร้างสรรค์
                  ์งานวรรณกรรม ชื่อเจ้าของลิขสิทธิ์ สำนักพิมพ์ วัน เดือน ปี ที่พิมพ์ ตราสัญลักษณ์ของ www.hytexts.com
                  และโฆษณางานครั้งแรก วันเดือนปีที่พิมพ์ และโฆษณางานครั้งปัจจุบันเป็น อย่างน้อย โดยระบุถ้อยคำว่า
                  “ได้รับอนุญาตจากเจ้าของลิขสิทธิ์” และ “สงวนลิขสิทธิ์ พ.ศ. .....” และ “ อนุญาตให้จัดจำหน่ายใน
                  www.hytexts.com เท่านั้น” ให้ปรากฏในส่วนที่สังเกตเห็นได้ชัดเจน
               </p>
            </div>

            <div>
               <h2>8. ขอบเขตการรับผิดชอบต่อ ความเสียหาย</h2>
               <p>
                  www.hytexts.com
                  ตกลงว่าจะพยายามถึงที่สุดที่จะป้องกันการละเมิดลิขสิทธิ์งานวรรณกรรมในรูปแบบหนังสืออิเล็กทรอนิกส์ โดย
                  www.hytexts.com จะไม่รับผิดชอบต่อ ความเสียหายจากการละเมิดลิขสิทธิ์ของงาน
                  วรรณกรรมในรูปแบบหนังสืออิเล็กทรอนิกส์ที่ เกิดจากกรณีดังต่อไปนี้
               </p>

               <ol>
                  <li>
                     การละเมิดลิขสิทธิ์ตัวอย่างงานวรรณกรรม ในรูปแบบหนังสืออิเล็กทรอนิกส์ที่ถูกใช้เพื่อการ
                     ประชาสัมพันธ์หรือไม่ถูกใช้ในเชิงพาณิชย์
                  </li>
                  <li>
                     การทำลายการเข้ารหัสและระบบป้องกัน การละเมิดลิขสิทธิ์ของงานวรรณกรรมในรูปแบบ
                     หนังสืออิเล็กทรอนิกส์จากบุคคลอื่น
                  </li>
                  <li>
                     การจับภาพหน้าจอแสดงผลจากคอมพิวเตอร์ ส่วนบุคคล คอมพิวเตอร์แบบพกพา โทรศัพท์มือถือ
                     และอุปกรณ์อ่านหนังสืออิเล็กทรอนิกส์ ที่แสดงผล หนังสืออิเล็กทรอนิกส์ของนักเขียน
                  </li>
                  <li>
                     การคัดลอกข้อความ เนื้อหา หน้าปก และรูปภาพ หรือส่วนใดส่วนหนึ่ง ในงานวรรณกรรมรูปแบบ
                     หนังสืออิเล็กทรอนิกส์จากบุคคลอื่น
                  </li>
                  <li>การเจาะฐานข้อมูลหนังสืออิเล็กทรอนิกส์ของ www.hytexts.com จากบุคคลผู้ไม่หวังดี</li>
                  <li>
                     www.hytexts.com ขอสงวนสิทธิการรับผิดชอบ ต่อความเสียหายในกรณีที่ข้อมูลภายในเว็บสูญหาย
                     หรือข้อมูลผิดพลาดไม่ครบถ้วน อันเกิดจากความ ผิดพลาดของอุปกรณ์ของผู้ให้บริการ Web Hosting
                     หรือจากเหตุสุดวิสัยอื่นใด แม้ www.hytexts.com มีการสำรองข้อมูลไว้
                  </li>
               </ol>
            </div>

            <div>
               {' '}
               <h2>9. การต่อสู้คดี</h2>
               <ol>
                  <li>
                     นักเขียนตกลงว่าจะใช้ความระมัดระวังในการนำ ส่งข้อมูลหนังสืออิเล็กทรอนิกส์ ในกรณีที่เกิดพิพาท
                     หรือในการใช้สิทธิ์ทางศาลกับบุคคลที่สาม เนื่องจาก ข้อมูลต่างๆ ไปละเมิดลิขสิทธิ์ หมิ่นประมาท หรือ
                     มีเนื้อหา ดังที่ได้ระบุใน ข้อ (4) เป็นเหตุให้ www.hytexts.com ได้รับความเสียหาย หรือ
                     www.hytexts.com ต้องชำระค่าเสียหายให้แก่ บุคคลที่สาม นักเขียนยินยอมชำระค่าเสียหายให้แก่
                     www.hytexts.com ตามความเป็นจริง
                  </li>
                  <li>
                     ในกรณีที่มีบุคคลอื่นละเมิดลิขสิทธิ์ใน งานวรรณกรรมภายใต้ข้อตกลงนี้ นักเขียนตกลง มอบอำนาจให้
                     www.hytexts.com ในการร้องทุกข์ ฟ้องร้อง และดำเนินคดี โดยจะจัดทำหนังสือมอบ อำนาจให้แก่ตัวแทนทันที
                  </li>
               </ol>
            </div>

            <div>
               <h2>10. กฎหมายที่ใช้บังคับ</h2>
               <p>
                  ข้อตกลงฉบับนี้ให้อยู่ภายใต้บังคับแห่งกฎหมายไทย นักเขียนได้อ่านและเข้าใจข้อความในข้อตกลงโดย ตลอดดีแล้ว
               </p>
               <br />
               <h2>เงื่อนไขและข้อตกลงในการสมัครเป็นสมาชิกกับ www.hytexts.com</h2>
               <p>
                  โปรดอ่านทำความเข้าใจตามเงื่อนไขและข้อตกลงก่อนทำการลงทะเบียน หลังจากที่การลงทะเบียนเสร็จ สมบูรณ์แล้ว
                  ถือว่าท่านยอมรับเงื่อนไขและข้อตกลง ระหว่างสมาชิก กับ บริษัท ไฮเท็คซ์ อินเตอร์แอคทีฟ จำกัด หรือ
                  www.hytexts.com
                  <br />
                  ทั้งสองฝ่ายตกลงทำข้อตกลงกันดังมีข้อความ ดังต่อไปนี้
               </p>
            </div>

            <div>
               <h2>หนังสืออิเล็กทรอนิกส์ (E-BOOK)</h2>
               <ol>
                  <li>
                     หนังสืออิเล็กทรอนิกส์ที่ถูกตั้งราคาขายใน www.hytexts.com จะถูกเข้ารหัสเพื่อจัดการลิขสิทธ์ (Digital
                     Right Management) ยกเว้น หนังสือ อิเล็กทรอนิกส์ที่จัดจำหน่ายแบบ DRM-Free
                  </li>
                  <li>
                     สมาชิกหรือนักเขียนจะต้องสมัคร Adobe ID ก่อนที่จะดาวน์โหลดหนังสืออิเล็กทรอนิกส์ เพื่อที่จะ
                     สามารถนำไปอ่านในอุปกรณ์พกพาอื่นๆได้ เช่น iPad iPhone Android e-Reader Pc และ Mac
                  </li>
                  <li>สมาชิกหรือนักเขียนสามารถ Authorize อุปกรณ์พกพาได้สูงสุด 5 อุปกรณ์ ต่อ 1 Adobe ID</li>
                  <li>
                     หนังสืออิเล็กทรอนิกส์ และ ตัวอย่างหนังสือ อิเล็กทรอนิกส์ ที่ถูกจัดจำหน่ายโดย www.hytexts.com
                     ห้ามทำซ้ำ ดัดแปลง แก้ไข เผยแพร่ จัดจำหน่าย โดยไม่ได้รับอนุญาตจาก www.hytexts.com
                  </li>
               </ol>
            </div>

            <div>
               <h2>HYTEXTS CREDIT</h2>
               <ol>
                  <li>
                     Hytexts Credit เป็นสื่อกลางสำหรับใช้ชำระค่าสินค้าแทนเงินสดใน www.hytexts.com และแอปพลิเคชัน Hytexts
                     เท่านั้น
                  </li>
                  <li>Hytexts Credit ที่สมาชิกสั่งซื้อไม่มีวันหมดอายุ</li>
                  <li>
                     Hytexts Credit ที่สมาชิกได้รับตอนสมัครสมาชิก ใหม่หรือจากโปรโมชันอื่นๆ ไม่มีวันหมดอายุ และ
                     สามารถนำมาใช้ชำระค่าสินค้าใน www.hytexts.com และแอปพลิเคชัน Hytexts ได้
                  </li>
                  <li>
                     Hytexts Credit เมื่อสั่งซื้อและได้รับเข้าบัญชีของสมาชิกหรือนักเขียนแล้ว
                     ไม่สามารถแลกเป็นเงินสดหรือโอนให้สมาชิกท่าน อื่นได้
                  </li>
                  <li>
                     ในการชำระเงินด้วย Hytexts Credit จะมีการตรวจสอบรหัสผ่าน (Password) ทุกครั้ง
                     หากสมาชิกตกลงให้ถือว่าการกระทำนั้นมีผลสมบูรณ์ ยินยอมว่าได้ตกลงชำระค่าสินค้าดังกล่าวด้วย Hytexts
                     Credit โดยชอบด้วยกฎหมายแล้ว
                  </li>
                  <li>
                     www.hytexts.com จะเติม Hytexts Credit เข้าบัญชีของสมาชิกหลังจากได้รับแจ้งผลการโอนเงินภายใน 2
                     ชั่วโมง เฉพาะเวลา 8.00-16.45น. (จันทร์ - เสาร์) ถ้านอกเหนือเวลาดังกล่าว Hytexts Credit
                     จะเข้าบัญชีของสมาชิกในวันทำการถัดไป
                  </li>
                  <li>
                     เงื่อนไขของ Hytexts Credit สามารถเปลี่ยนแปลงไปตามที่ www.hytexts.com กำหนด และ www.hytexts.com
                     ขอสงวนสิทธิ์ใน การเปลี่ยนแปลงเงื่อนไขได้ตามที่เห็นสมควร โดยจะแจ้งให้ทราบเมื่อมีการเปลี่ยนแปลง
                  </li>
               </ol>
            </div>

            <div>
               {' '}
               <h2>สมาชิกทั่วไป</h2>
               <ol>
                  <li>การสมัครสมาชิกกับ www.hytexts.com ไม่ต้องเสียค่าใช้จ่ายใดๆทั้งสิ้น</li>
                  <li>
                     ผู้ที่ต้องการสมัครสมาชิก ต้องกรอกข้อมูลของตนเองที่เป็นจริงให้แก่ www.hytexts.com ให้ครบทุกข้อ
                     เพื่อสิทธิประโยชน์ ์ของท่านในการเข้าร่วมกิจกรรมของ www.hytexts.com หาก www.hytexts.com
                     ตรวจสอบพบว่าท่านให้ข้อมูลเท็จ ทีมงานมีสิทธิ์ไม่ให้ ้สิทธิ์การเป็นสมาชิกได้หรือยกเลิกการเป็นสมาชิกได
                  </li>
                  <li>
                     ผู้ใดแอบอ้าง หรือกระทำการใดๆ อันเป็น การละเมิดสิทธิ์ส่วนบุคคล โดยใช้ข้อมูลของผู้อื่น
                     มาแอบอ้างสมัครสมาชิกเพื่อให้ได้สิทธิ์การสมาชิก ถือเป็นความผิด ต้องรับโทษตามที่กฎหมายกำหนดไว้
                  </li>
                  <li>
                     เพื่อความเป็นส่วนตัวและความปลอดภัยใน ข้อมูลของท่านเอง www.hytexts.com ขอแจ้ง ให้ทราบว่า
                     เป็นหน้าที่ของสมาชิกในการรักษาข้อมูลชื่อ Login และ Password โดยไม่บอกให้ผู้อื่นทราบ
                  </li>
                  <li>
                     สมาชิกสามารถเปลี่ยนแปลงรหัสผ่าน (Password) ด้วยตนเองได้ตลอดระยะเวลาการใช้งาน โดยไม่ต้องแจ้งให้
                     www.hytexts.com ทราบ ทั้งนี้สมาชิกตกลงให้รหัสผ่าน (Password) ที่เปลี่ยนแปลงไปในแต่ละขณะดังกล่าว
                     เป็นรหัสผ่านการใช้บริการของ www.hytexts.com ที่มีผลผูกพันสมาชิก
                     ตามข้อกำหนดและเงื่อนไขการใช้บริการนี้ทุกประการ
                  </li>
                  <li>
                     การกระทำการใดๆ โดยผ่านบริการ ไม่ว่ากรณีใดๆก็ตาม
                     หากกระทำโดยใช้รหัสสมาชิกและรหัสผ่านของสมาชิกและ/หรือตรงตามวิธีการหรือเงื่อนไขที่บริษัทกำหนดไว้เกี่ยวกับการใช้บริการ
                     www.hytexts.com แล้ว สมาชิกตกลงให้ถือว่าการกระทำนั้นมีผลสมบูรณ์
                     โดยสมาชิกไม่ต้องลงลายมือชื่อเป็นหลักฐานในเอกสารใดๆ อีก
                     และยินยอมรับผิดชอบในการกระทำดังกล่าวเสมือนหนึ่งว่าสมาชิกเป็นผู้กระทำด้วยตนเอง
                     ทั้งนี้ไม่ว่าจะเกิดขึ้นด้วยความทุจริตของบุคคลภายนอกหรือไม่ก็ตาม
                     สมาชิกจะไม่เรียกร้องให้บริษัทต้องรับผิดชอบแต่อย่างใด
                  </li>
                  <li>
                     รหัสผ่าน (Password) ถือเป็นความลับเฉพาะตัวของสมาชิกที่ต้องเก็บรักษาและปกปิดมิให้ผู้อื่นล่วงรู้
                     สมาชิกต้องเก็บรักษาไว้ด้วยตนเอง หากมีการใช้บริการรายการใดๆโดยใช้รหัสผ่าน (Password) ของสมาชิกแล้ว
                     ให้ถือว่าถูกต้องสมบูรณ์มีผลผูกพันสมาชิกเสมือนสมาชิกใช้บริการในครั้งนั้นๆ ด้วยตนเอง ทั้งนี้
                     บริษัทไม่สามารถล่วงรู้รหัสผ่าน (Password) ของสมาชิกได้ ดังนั้น
                     บริษัทจึงไม่ต้องรับผิดชอบในความเสียหายใดๆที่เกิดขึ้นในการใช้บริการ www.hytexts.com โดยรหัสผ่าน
                     (Password) ของสมาชิก
                  </li>
                  <li>
                     สมาชิกจำเป็นต้องตรวจสอบความถูกต้องในการทำรายการสั่งซื้อหนังสืออิเล็กทรอนิกส์ว่าถูกต้องหรือไม่
                     ก่อนที่จะทำการตกลงชำระเงิน
                     ซึ่งถ้าหากเกิดข้อผิดพลาดจากการทำรายการสั่งซื้อหนังสืออิเล็กทรอนิกส์อันเนื่องมาจากความไม่ถูกต้องของรายการเนื่องมาจากความผิดพลาดของสมาชิกเอง
                     ทาง www.hytexts.com จะไม่รับผิดชอบทั้งสิ้น
                  </li>
                  <li>หนังสืออิเล็กทรอนิกส์เมื่อชำระเงินแล้ว สมาชิกไม่สามารถขอคืนเงินได้</li>
                  <li>
                     หากมีความผิดพลาดของข้อมูลหรือเนื้อหาของหนังสืออิเล็กทรอนิกส์ที่สมาชิกได้สั่งซื้อแล้วนั้น
                     หลังจากที่ได้ทำการแก้ไขเนื้อหาหรือข้อมูลแล้ว สมาชิกสามารถลบหนังสืออิเล็กทรอนิกส์เล่มนั้นๆ ที่หน้า
                     My Library ของสมาชิก และดาวน์โหลดหนังสืออิเล็กทรอนิกส์เล่มนั้นๆ ใหม่อีกครั้ง
                  </li>
                  <li>
                     ถ้า www.hytexts.com พบว่าสมาชิกทำรายการสั่งซื้อหนังสืออิเล็กทรอนิกส์หรือ Hytexts Credit
                     โดยชำระเงินผ่านบัญชีธนาคารหรือบัตรเครดิต โดยไม่มีการชำระเงินจริงเกิดขึ้นหลายครั้ง
                     เพื่อป้องกันการสร้างปัญหาให้กับระบบของ www.hytexts.com ทีมงานมีสิทธิ์ยกเลิกความเป็นสมาชิกได้ทันที
                  </li>
                  <li>
                     ถ้า www.hytexts.com พบว่าสมาชิกนำหนังสืออิเล็กทรอนิกส์และตัวอย่างหนังสืออิเล็กทรอนิกส์ของ
                     www.hytexts.com ไปทำซ้ำ ดัดแปลง แก้ไข เผยแพร่ หรือจัดจำหน่าย โดยไม่ได้รับอนุญาตจาก www.hytexts.com
                     ทีมงานมีสิทธิ์ยกเลิกความเป็นสมาชิกได้โดยทันที
                  </li>
                  <li>
                     หนังสืออิเล็กทรอนิกส์ที่สมาชิกสั่งซื้อไป ห้ามทำซ้ำหรือดัดแปลง ห้ามให้เช่าต้นฉบับหรือสำเนางาน
                     ห้ามเผยแพร่งานต่อสาธารณชน หากผู้ใดกระทำการดังกล่าว ถือเป็นการละเมิดลิขสิทธิ์
                     ต้องรับโทษอาญาและจ่ายค่าเสียหายแก่เจ้าของลิขสิทธิ์และ www.hytexts.com ด้วย
                     หากผู้ใดรู้อยู่แล้วหรือมีเหตุอันควรรู้ว่างานใดได้ทำขึ้นโดยละเมิดลิขสิทธิ์ของผู้อื่น
                     กระทำการต่อไปนี้แก่งานนั้นเพื่อหากำไร ให้ถือว่าผู้นั้นกระทำละเมิดลิขสิทธิ์ด้วย ได้แก่ <br />
                     13.1 ขาย มีไว้เพื่อขาย เสนอขาย ให้เช่า เสนอให้เช่า ให้เช่าซื้อ หรือเสนอให้เช่าซื้อ
                     <br />
                     13.2 เผยแพร่ต่อสาธารณชน <br />
                     13.3 แจกจ่ายในลักษณะที่อาจก่อให้เกิดความเสียหายแก่เจ้าของลิขสิทธิ์
                  </li>
                  <li>
                     สมาชิกจะต้องไม่โพสต์ข้อความที่มีเนื้อหาดังต่อไปนี้ที่ www.hytexts.com
                     <br />
                     14.1 ไม่โพสต์ข้อความซึ่งพาดพิงหรือลบหลู่ สถาบันพระมหากษัตริย์
                     <br />
                     14.2. ไม่โพสต์ข้อมูลหยาบคาบ หมิ่นประมาณ หรือสร้างความเสียหายต่อบุคคลหนึ่งบุคคลใด
                  </li>
                  <li>
                     www.hytexts.com จะไม่รับผิดชอบต่อความสูญเสียในด้านข้อมูลสมาชิก ข้อมูลการสั่งซื้อ
                     และข้อมูลทุกๆอย่างภายในเว็บไซต์หากมีการสูญหาย
                     จากการถูกจารกรรมความผิดพลาดจากระบบของเครื่องแม่ข่ายที่เก็บข้อมูลหรือความผิดพลาดที่เกิดจากระบบเว็บไซต์ทั้งสิ้น
                  </li>
                  <li>
                     หากพบว่าสมาชิกกระทำการที่ผิดเงื่อนไขและข้อตกลงกับ www.hytexts.com
                     ทีมงานมีสิทธิ์ที่จะยกเลิกความเป็นสมาชิกได้โดยทันที
                  </li>
                  <li>
                     ในกรณีที่ดาวน์โหลดหนังสืออิเล็กทรอนิกส์แบบ DRM-free สมาชิกตกลงให้ฝังข้อมูล ชื่อ-นามสกุล อีเมล์
                     รหัสสั่งซื้อ และข้อมูล IP ลงไปในข้อมูลหนังสืออิเล็กทรอนิกส์
                  </li>
               </ol>
            </div>

            <div>
               <h2>ขั้นตอนการดำเนินการต่อเนื้อหาที่เข้าข่ายผิดกฎหมาย</h2>
               <p>
                  หากพบว่ามีผลงานที่เข้าข่ายผิดกฎหมาย สำนักงานจะดำเนินการระงับการเผยแพร่และแจ้งให้เจ้าของผลงานทราบ เพื่อ
                  ดำเนินการแก้ไขต่อไป และหากพบว่าเจ้าของผลงานมีการส่งผลงานที่ผิดกฎหมายเข้ามาซ้ำซาก สำนักงานจะดำเนิน
                  การระงับบัญชีผู้ใช้ของเจ้าของผลงานต่อไป
                  ผู้ที่ประสงค์จะให้สำนักงานในฐานะผู้ให้บริการดำเนินการต่อเนื้อหาที่เข้า ข่ายผิดกฎหมาย <br />
                  สามารถดำเนินการแจ้งสำนักงานได้พร้อมเอกสารหลักฐานประกอบแล้วส่งมาที่
               </p>
            </div>

            <b>บริษัท ไฮเท็คซ์ อินเตอร์แอคทีฟ จำกัด</b>
            <p>
               เลขที่ 3 อาคารพร้อมพันธุ์ 3 ชั้นที่ 7 ห้องเลขที่ 701-702 ซอยลาดพร้าว 3 ถนนลาดพร้าว แขวงจอมพล เขตจตุจักร
               กทม 10900 <br />
               โทร. 02-024-6690 <br />
               Customer Service : 089-134-7470 <br />
               E-mail : contact@hytexts.com <br />
               ช่วงเวลาทำการ: จันทร์-ศุกร์ 09:00-18:00 น. <br />
               <br />
               <br />
               บริษัทจะดำเนินการและตอบกลับภายใน 7 วันทำการ
            </p>

            <div>
               {' '}
               <h2>การจัดระดับการนำเสนอเนื้อหาที่เหมาะสมต่อผู้ใช้บริการแต่ละกลุ่ม</h2>
               <p>
                  บริษัทฯ มีหลักเกณฑ์ในการจัดระดับการนำเสนอเนื้อหาที่เหมาะสมต่อผู้ใช้บริการแต่ละกลุ่ม โดยคำนึงถึง
                  ปัจจัยหลักใน การจัดอันดับขายดี คือ ยอดขาย และ ปัจจัยหลักในการจัดระดับหนังสือที่คุณน่าจะสนใจ
                  ขึ้นกับความเกี่ยวข้องของ
                  <br />
                  <br />
                  <br />
                  หนังสือที่ผู้ใช้บริการมี ซึ่งแพลตฟอร์มจะแบ่งเนื้อหาออกเป็น 3 ประเภท โดย
                  <br />
                  <br />
                  - ประเภทแรก คือ เนื้อหาทั่วไปที่สามารถเข้าถึงได้บนหน้าเว็บไซต์ <br />- ประเภทสอง คือ
                  เนื้อหาที่เหมาะกับผู้ใช้งานที่มีอายุ 18 ปีขึ้นไป โดยจะมีสัญลักษณ์ 18+ หรือ 18 ปีขึ้นไป <br />
                  - ประเภทสาม คือ เนื้อหาที่เหมาะกับผู้ใช้งานบางกลุ่ม ซึ่งจะจำกัดการแสดงผลให้เฉพาะผู้ใช้บางกลุ่มเท่านั้น
                  เช่น หนังสือรุ่น เป็นต้น
                  <br />
                  <br />
                  ทั้งนี้ ผลงานใดจะอยู่ในระดับ/ประเภทไหน ขึ้นกับการตรวจสอบและพิจารณาของเจ้าหน้าที่
                  โดยจะพิจารณาจากเนื้อหาของผลงานนั้นๆ
               </p>
               <br />
               <h2>การจำกัดพื้นที่ข้อมูลและการละเมิดสิทธิส่วนบุคคล</h2>
               <p>
                  การพยายามลักลอบเข้าไปยังพื้นที่ข้อมูลที่ไม่ได้รับอนุญาต ถือเป็นการละเมิดสิทธิส่วนบุคคล
                  และหากพิสูจน์ได้ว่ามีบุคคลใดนำข้อมูลส่วนบุคคลของผู้อื่นไปใช้โดยมิชอบ หรือกระทำการใดๆ กับข้อมูลทำให้
                  เกิดความเสียหายตามมา บุคคลผู้นั้นจะถูกดำเนินคดีตามกฎหมายถึงที่สุด
               </p>
               <br />
               <h2>การให้ข้อมูลและการใช้ภาษา</h2>
               <p>
                  บางครั้งผู้ใช้บริการอาจมีการให้ข้อมูล ส่งต่อ หรือสอบถาม โดยส่งมายังเจ้าหน้าที่ของบริษัทฯ
                  เขียนข้อวิจารณ์เพื่อขึ้นเว็บไซต์ หรือส่งอีเมล์ต่อไปยังผู้อื่น
                  ทั้งนี้ผู้ใช้บริการยืนยันว่าจะไม่ใช้ภาษาที่ไม่สุภาพ ส่อเสียด ข่มขู่ ทำให้เกิดจดหมายลูกโซ่
                  หรือการใช้ที่ผิดวัตถุประสงค์ และไม่ส่งข้อมูลที่มีโปแกรมไวรัส นอกจากนี้
                  ผู้ใช้บริการยืนยันที่จะให้ข้อมูลที่เป็นจริง ไม่มีการแอบอ้างชื่อบุคคล องค์กร
                  หรือข้อมูลใดที่จะทำให้เกิดความเข้าใจผิดกับผู้อ่าน
                  ในกรณีที่ข้อมูลผ่านการตรวจสอบจากเจ้าหน้าที่ของบริษัทฯ ให้ปรากฎอยู่ในเว็บไซต์มิได้หมายความว่า บริษัทฯ
                  ยืนยันความถูกต้องของเนื้อหาหรือข้อมูล
                  แต่หากผ่านการพิจารณาว่ามีการใช้ภาษาที่เหมาะสมในระดับหนึ่งเท่านั้น
               </p>
            </div>

            <div>
               <h2>มาตรการดูแลผู้ใช้บริการ</h2>
               <p>มาตรการดูแลผู้ใช้บริการซึ่งได้รับความเสียหายจากการใช้บริการเป็นไปตามนโยบายของบริษัทฯ</p>
            </div>
         </div>
      </Modal>
   );
};

export default TermsOfUseModal;
